import {
  TokenPair,
  TokenPairItem,
  Exchange,
  ScreenerTokenRaw,
  ScreenerTokensResponse,
} from "./types";

export const selectTokenScreenerTokens: (
  response: ScreenerTokensResponse,
) => ScreenerTokensResponse = (response: ScreenerTokensResponse) => {
  return {
    ...response,
    results:
      response?.results?.map((apiToken: ScreenerTokenRaw) => {
        const rawToken0 = apiToken.pair.token0Data;
        const rawToken1 = apiToken.pair.token1Data;

        const token0Exchanges = rawToken0.exchanges.map(
          (ex): Exchange => ({
            id: ex.id,
            address: ex.id,
            networkId: ex.networkId,
            iconUrl: ex.iconUrl,
          }),
        );
        const token1Exchanges = rawToken1.exchanges.map(
          (ex): Exchange => ({
            id: ex.id,
            address: ex.id,
            networkId: ex.networkId,
            iconUrl: ex.iconUrl,
          }),
        );

        const token0Data: TokenPairItem = {
          address: rawToken0.address,
          circulatingSupply: rawToken0.circulatingSupply,
          exchanges: token0Exchanges,
          id: rawToken0.id,
          isScam: rawToken0.isScam,
          name: rawToken0.name,
          networkId: rawToken0.networkId,
          symbol: rawToken0.symbol,
          totalSupply: rawToken0.totalSupply,
        };

        const token1Data: TokenPairItem = {
          address: rawToken1.address,
          circulatingSupply: rawToken1.circulatingSupply,
          exchanges: token1Exchanges,
          id: rawToken1.id,
          isScam: rawToken1.isScam,
          name: rawToken1.name,
          networkId: rawToken1.networkId,
          symbol: rawToken1.symbol,
          totalSupply: rawToken1.totalSupply,
        };

        const tokenPair: TokenPair = {
          id: apiToken.pair.id,
          address: apiToken.address,
          exchangeHash: apiToken.pair.exchangeHash,
          networkId: apiToken.pair.networkId,
          token0: apiToken.pair.token0,
          token0Data: token0Data,
          token1: apiToken.pair.token1,
          token1Data: token1Data,
        };

        const result = {
          tokenId: apiToken.tokenId,
          name: apiToken.name,
          symbol: apiToken.symbol,
          decimals: apiToken.decimals,
          icon: apiToken.icon,
          otherTokenIcon: apiToken.otherTokenIcon,
          networkLogo: apiToken.networkLogo === 0 ? "ethereum" : "solana",
          isFavourite: false, // fix me
          socialLinks: apiToken.socialLinks,
          address: apiToken.address,
          price: Number(apiToken.price),
          age: apiToken.age,
          txns: apiToken.txns,
          makers: apiToken.makers,
          holders: apiToken.holders,
          volume: Number(apiToken.volume),
          liquidity: Number(apiToken.liquidity),
          marketCap: Number(apiToken.marketCap),
          totalSupply: Number(apiToken.totalSupply),
          priceChange1Hour: Number(apiToken.priceChange1Hour),
          priceChange24Hours: Number(apiToken.priceChange24Hours),
          exchange: apiToken.exchange,
          pair: tokenPair,
          quoteToken: apiToken.quoteToken,
        } as ScreenerTokenRaw;

        return result;
      }) ?? [],
  };
};
